import React from 'react';
import { EventContentArg } from '@fullcalendar/react';
import { CalendarDateService } from '@uplift/services';


export const isFirstPatientSession = (event: EventContentArg['event'], patientCounts: Record<string, {id: string}[]>) => {
  const firstPatientAppointment =
    patientCounts?.[event.extendedProps.patientId]?.[0];
  const appointment = event.extendedProps?.appointment?.[0];

  const isFirstSession = (
    firstPatientAppointment?.id
    && appointment?.id
    && firstPatientAppointment?.id === appointment?.id
  );

  return isFirstSession;
};


export const useEventDuration = (start?: Date | null, end?: Date | null, timezone?: string) => {
  return React.useMemo(() => {
    if (!start || !end) {
      return {
        startTime: null,
        endTime: null,
        duration: 0,
      };
    }

    const startTime = CalendarDateService
      .date(start)
      .tz(timezone);
    const endTime = CalendarDateService
      .date(end)
      .tz(timezone);

    return {
      startTime,
      endTime,
      duration: endTime.diff(startTime, 'minutes'),
    };
  }, [ start, end, timezone ]);
};
